import * as t from "io-ts";
import { JobItem } from "./JobItem";
import { WorkType } from "./WorkType";

export const JobInfo = t.type({
  job_items: t.array(JobItem),
  work_type: WorkType,
});

export interface JobInfo {
  job_items: Array<JobItem>;
  work_type: WorkType;
}
